var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mt-header',{attrs:{"title":_vm.msg,"fixed":""}},[_c('mt-button',{attrs:{"slot":"left","icon":"back"},on:{"click":_vm.handleback},slot:"left"}),(_vm.isSearch)?_c('img',{staticClass:"search-img",attrs:{"slot":"right","src":require("@/assets/search.png")},on:{"click":_vm.search},slot:"right"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }